"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledColumnedTitleText = exports.StyledColumnedTitleLabel = exports.StyledTitleText = exports.StyledTitleLabel = exports.StyledTitleElement = exports.StyledColumnedTitleElement = exports.StyledTitleContainer = void 0;
// styles
const Theme_1 = require("../../Theme/Theme");
exports.StyledTitleContainer = Theme_1.styled.div `
  margin: 0 auto;
`;
exports.StyledColumnedTitleElement = Theme_1.styled.div `
  height: 30px;
  display: flex;
  background: ${(props) => props.theme.colors.gray[10]};
`;
exports.StyledTitleElement = Theme_1.styled.div `
  width: 616px;
  height: 30px;
  display: flex;
  background: ${(props) => props.theme.colors.gray[10]};
`;
exports.StyledTitleLabel = Theme_1.styled.div `
  vertical-align: middle;
  width: ${(props) => props.width};
  height: ${(props) => props.height}px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: ${(props) => props.paddingLeft}px;
  padding-right: ${(props) => props.paddingRight}px;
  flex: auto;
`;
exports.StyledTitleText = Theme_1.styled.p `
  display: block;
  width: ${(props) => props.width};
  height: ${(props) => props.height}px;
  margin-block-start: 0em;
  margin-block-end: 0em;
  color: ${(props) => props.theme.colors.gray[70]};
  list-style: none;
  font-size: 14px;
  font-weight: 600;
  font-family: proxima-nova, arial, sans-serif;
`;
exports.StyledColumnedTitleLabel = Theme_1.styled.div `
  vertical-align: middle;
  width: ${(props) => (props.width === 'auto' ? 'auto' : `${props.width}px`)};
  height: ${(props) => props.height}px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: ${(props) => props.paddingLeft}px;
  padding-right: ${(props) => props.paddingRight}px;
  flex: auto;
`;
exports.StyledColumnedTitleText = Theme_1.styled.p `
  display: block;
  width: ${(props) => (props.width === 'auto' ? 'auto' : `${props.width}px`)};
  height: ${(props) => props.height}px;
  margin-block-start: 0em;
  margin-block-end: 0em;
  color: ${(props) => props.theme.colors.gray[70]};
  list-style: none;
  font-size: 14px;
  font-weight: 600;
  font-family: proxima-nova, arial, sans-serif;
`;
//# sourceMappingURL=DropdownTitle.styles.js.map